import { ApiError } from '@/lib/api'
import { formatDateTime } from '@/lib/format-date'
import { DataGrid, type auditLogGridContract, type DataGridColumnRenderers } from '@/modules/data-grid'

import { auditLogRenderers } from '../../audit-log-renderers'
import { SUBJECT_COLUMNS } from '../../routes'

import { useSubjectAuditLogGrid, type AuditSubjectType } from './subject-audit-log-queries'

const subjectRenderers: DataGridColumnRenderers<typeof auditLogGridContract> = {
  ...auditLogRenderers,
  timestamp: {
    cell: ({ value }) => value ? <time dateTime={value}>{formatDateTime(value)}</time> : '—',
  },
}

export function SubjectAuditLog({
  entityId,
  subjectType,
  subjectId,
  urlState,
  caption,
}: {
  entityId: string
  subjectType: AuditSubjectType
  subjectId: string
  urlState: boolean
  caption: string
}) {
  const grid = useSubjectAuditLogGrid(entityId, subjectType, subjectId, urlState)
  if (grid.query.error instanceof ApiError && grid.query.error.status === 403)
    return <p role="alert" className="text-destructive text-sm">You don’t have permission to view this audit log.</p>
  return (
    <DataGrid
      grid={grid}
      caption={caption}
      regionLabel="Audit activity"
      noun="records"
      searchLabel="audit log"
      emptyMessage={grid.activeCriteria.search || grid.activeCriteria.filter?.length
        ? 'No activity matches your search or filters.'
        : 'No activity recorded yet.'}
      columnChooserColumns={SUBJECT_COLUMNS}
      renderers={subjectRenderers}
    />
  )
}
